var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("aside", { staticClass: "menu category-list" }, [
    _vm.sortedItems
      ? _c(
          "ul",
          { staticClass: "menu-list" },
          _vm._l(_vm.items, function (item) {
            return _c(
              "li",
              { key: item.id },
              [
                _c("CategoryListItem", {
                  attrs: {
                    item: item,
                    "is-active": _vm.checkActive(item.id),
                    "is-leaf-node": !item.children,
                  },
                  on: {
                    "link-click": function ($event) {
                      return _vm.toggleActiveCategory(item.id)
                    },
                  },
                }),
                _vm._v(" "),
                item.children
                  ? _c("CategoryList", {
                      class: { "is-hidden": !_vm.checkActive(item.id) },
                      attrs: { items: item.children },
                    })
                  : _vm._e(),
              ],
              1
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }